import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getUserProfile = async () => {
  const account = localStorage.getItem('admin_email') || '';
  if (!account) return null;
  try {
    const r = await axios.get(`${API}/admin/user-profile/${encodeURIComponent(account)}`);
    return r.data;
  } catch {
    return null;
  }
};
